import { Popover } from '@headlessui/react';
import { Link } from '@remix-run/react';
import { getRandomImage } from '@theprintbar/shared';

interface CartEmptyProps {
	isMobile?: boolean;
	quoteSession?: any;
}

export function CartEmpty({ isMobile = false, quoteSession }: CartEmptyProps) {
	return (
		<>
			{!isMobile ? (
				<div className="p-8">
					<h4 className="text-lg mb-6 uppercase">Your {quoteSession ? 'quote' : 'cart'} is empty</h4>
				</div>
			) : (
				<div className="text-blue">
					<h4 className="text-sm my-6 uppercase">Your {quoteSession ? 'quote' : 'cart'} is empty</h4>
				</div>
			)}
		</>
	);
}
